import { CheckNotes, InspectionCase } from '../../inspection-cases';
import { DeploymentAgainstEarthquakes } from './deployment-against-earthquakes.dto';
import { FoamCenter } from './foam-center.dto';
import { PreactionSystems } from './preaction-systems.dto';
import { SprinklerSystemDesignMain } from './sprinkler-system-design-main.dto';
import { SprinklerSystems } from './sprinkler-systems.dto';
import { WaterFloodingSystems } from './water-flooding-systems.dto';

export class SprinklerSystemDesignDto extends InspectionCase {
  main?: SprinklerSystemDesignMain;
  closedWaterSprinklerSystems?: SprinklerSystems;
  waterFloodingSystems?: WaterFloodingSystems;
  preactionSystems?: PreactionSystems;
  deploymentAgainstEarthquakes?: DeploymentAgainstEarthquakes;
  foamCenter?: FoamCenter;
}

export class SprinklerSystemDesign extends SprinklerSystemDesignDto {
  constructor(
    data: SprinklerSystemDesignDto = {
      title: 'בדיקת תכנון מערכות מתזים במים',
      isApplicable: true
    }
  ) {
    super(data);
    this.main = new SprinklerSystemDesignMain(data.main);
    this.closedWaterSprinklerSystems = new SprinklerSystems(
      data.closedWaterSprinklerSystems
    );
    this.waterFloodingSystems = new WaterFloodingSystems(
      data.waterFloodingSystems
    );
    this.preactionSystems = new PreactionSystems(data.preactionSystems);
    this.deploymentAgainstEarthquakes = new DeploymentAgainstEarthquakes(
      data.deploymentAgainstEarthquakes
    );
    this.foamCenter = new FoamCenter(data.foamCenter);
  }

  setInspectionStatus(): void {
    this.main.setInspectionStatus();
    this.closedWaterSprinklerSystems.setInspectionStatus();
    this.waterFloodingSystems.setInspectionStatus();
    this.preactionSystems.setInspectionStatus();
    this.deploymentAgainstEarthquakes.setInspectionStatus();
    this.foamCenter.setInspectionStatus();
    this.isPassed =
      this.main.isPassed &&
      this.closedWaterSprinklerSystems.isPassed &&
      this.waterFloodingSystems.isPassed &&
      this.preactionSystems.isPassed &&
      this.deploymentAgainstEarthquakes.isPassed &&
      this.foamCenter.isPassed;
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.main.getNotes(),
      ...this.closedWaterSprinklerSystems.getNotes(),
      ...this.waterFloodingSystems.getNotes(),
      ...this.preactionSystems.getNotes(),
      ...this.deploymentAgainstEarthquakes.getNotes(),
      ...this.foamCenter.getNotes()
    ];
  }

  setAsApplicable() {
    this.isApplicable = true;
    this.main.setAsApplicable();
    this.closedWaterSprinklerSystems.setAsApplicable();
    this.waterFloodingSystems.setAsApplicable();
    this.preactionSystems.setAsApplicable();
    this.deploymentAgainstEarthquakes.setAsApplicable();
    this.foamCenter.setAsApplicable();
  }
}
